import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import ClientsAndSynergies from "./pages/ClientsAndSynergies";
import Contact from "./pages/Contact";
import News from "./pages/News";
import EsgeaPlatformAndChatbot from "./pages/EsgeaPlatformAndChatbot";
import She4SeaProfilingTool from "./pages/She4SeaProfilingTool";
import She4SeaMultiplierEvents from "./pages/She4SeaMultiplierEvents";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/clients-and-synergies" element={<ClientsAndSynergies />} />
        <Route path="/news" element={<News />} />
        <Route path="/esgea-platform-and-chatbot" element={<EsgeaPlatformAndChatbot />} />
        <Route path="/she4sea-profiling-tool" element={<She4SeaProfilingTool />} />
        <Route path="/she4sea-multiplier-events" element={<She4SeaMultiplierEvents />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;